/*
  THAANI — <thaani-loop>: stumme Video-Schleifen als Bildersatz in Sections.
  Vanilla JS, kein Framework. Markup kommt aus snippets/thaani-loop.liquid.

  Ohne JS, ohne IntersectionObserver oder bei prefers-reduced-motion bleibt das
  Poster stehen und die Datei wird gar nicht geladen (preload="none", kein
  autoplay im Markup). Gespielt wird nur, solange das Element im Bild ist.
*/

/*
  Das Skript haengt an mehreren Sections (Benefits, Produktion, Social) und
  wird pro Seite mehrfach ausgefuehrt. Eine Top-Level-Klasse wuerde beim
  zweiten Mal einen SyntaxError werfen, deshalb liegt alles im Guard.
*/
if (!customElements.get('thaani-loop')) {
  class ThaaniLoop extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;

      this.video = this.querySelector('video');
      if (!this.video) return;

      if (typeof IntersectionObserver === 'undefined') return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.inView = entry.isIntersecting;
            if (this.inView) {
              this.start();
            } else {
              this.stop();
            }
          });
        },
        { rootMargin: '0px 0px 10% 0px', threshold: 0.2 }
      );

      this.observer.observe(this);

      this.onMotionChange = this.handleMotionChange.bind(this);
      if (typeof this.reducedMotion.addEventListener === 'function') {
        this.reducedMotion.addEventListener('change', this.onMotionChange);
      }

      // Beim Tabwechsel haelt der Browser das Video an. Der Observer feuert dabei
      // nicht, weil sich am Sichtbereich nichts aendert — also selbst wieder
      // anwerfen, sonst bleibt die Kachel nach der Rueckkehr eingefroren stehen.
      this.onVisibilityChange = this.handleVisibilityChange.bind(this);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.reducedMotion && typeof this.reducedMotion.removeEventListener === 'function') {
        this.reducedMotion.removeEventListener('change', this.onMotionChange);
      }
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    start() {
      if (this.reducedMotion.matches) return;

      // preload="none" laesst die Quelle offen, bis wir sie brauchen
      if (this.video.preload === 'none') {
        this.video.preload = 'auto';
        this.video.load();
      }

      const played = this.video.play();
      // Autoplay kann trotz muted abgelehnt werden — dann bleibt das Poster stehen
      if (played && typeof played.catch === 'function') {
        played.catch(() => {});
      }
    }

    stop() {
      if (this.video.paused) return;
      this.video.pause();
    }

    handleVisibilityChange() {
      if (document.visibilityState !== 'visible') return;
      if (!this.inView) return;
      this.start();
    }

    handleMotionChange() {
      if (this.reducedMotion.matches) {
        this.video.pause();
        this.video.currentTime = 0;
      }
    }
  }

  customElements.define('thaani-loop', ThaaniLoop);
}
